import { environment } from 'src/environments/environment';
import { DraftStartingComponent } from './../draft-starting/draft-starting.component';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ResultboardService } from 'src/app/resultboard/resultboard.service';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialog, MatSnackBar, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-active-drafts2',
  templateUrl: './active-drafts2.component.html',
  styleUrls: ['./active-drafts2.component.scss']
})
export class ActiveDrafts2Component implements OnInit {
  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  activeDraftListener: Subscription;
  sub_isMobileScreen: Subscription;
  isMobile = false;
  pickChanges: Subscription;
  newLeague: Subscription;
  s_activeDraft: Subscription;
  s_connect: Subscription;
  paymentStatus: Subscription;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  activeDrafts: any = [];
  runningTotal = 0;
  user: any = null;
  darkMode= false;
  // s_disconnect: Subscription;
  constructor(private snackBar: MatSnackBar, private _resultboardService: ResultboardService, public dialog: MatDialog, private store: Store<any>, private router: Router) {
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
    this.store.select('authData').subscribe(state => {
      if (state[0]) {
        this.user = state[0];
        this.setupListeners();
      }
    });
    this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
      }
    });
  }

  ngOnInit() { }
  ngOnDestroy() {
    // if (this.s_disconnect) this.s_disconnect.unsubscribe();
    if (this.s_connect) this.s_connect.unsubscribe();
    if (this.activeDraftListener) this.activeDraftListener.unsubscribe();
    if (this.pickChanges) this.pickChanges.unsubscribe();
    if (this.newLeague) this.newLeague.unsubscribe();
    if (this.paymentStatus) this.paymentStatus.unsubscribe();
  }

  setupListeners() {
    // active drafts listener (list_active_draft)
    if (this.activeDraftListener) this.activeDraftListener.unsubscribe();
    
    // if (this.s_disconnect) this.s_disconnect.unsubscribe();
    // this.s_disconnect = this._resultboardService.disconnectEvent().subscribe(r => {
    //   this.openSnackBar('Connection Lost, Refreshing...', 'OK');
    //   if(this.confirmDialogRef)
    //   this.confirmDialogRef.close();
    //     setTimeout(()=>{
    //       this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
    //                               width: '500px',
    //                               data: { 'title': "We've lost connection", 'body': "To reconnect please reload the page."}
    //                             });
    //       this.confirmDialogRef.afterClosed().subscribe(res => {
    //             document.location.reload();
    //       });
    //     },1000);
            
    // });
    
    
    // if (this.s_activeDraft) this.s_activeDraft.unsubscribe();
    // this.s_activeDraft = this._resultboardService.activeDraftEmit({
    //   user_id: this.user.id,
    //   is_app: 1,
    //   is_connect: 1
    // }).subscribe(res => {
    //   this.s_activeDraft.unsubscribe();
    // });
    
    if (this.s_connect) this.s_connect.unsubscribe();
    this.s_connect = this._resultboardService.connectEvent().subscribe(r => {
      if (this.s_activeDraft) this.s_activeDraft.unsubscribe();
      this.s_activeDraft = this._resultboardService.activeDraftEmit({
        user_id: this.user.id,
        is_app: 1,
        is_connect: 1
      }).subscribe(res => {
        this.s_activeDraft.unsubscribe();
      });
    });
    
    this.activeDraftListener = this._resultboardService.listActiveDraft().subscribe(r => {
      if (r.status == 1) {
        this.activeDrafts = r.entities;
        // console.log(this.activeDrafts);
        const noIndex = this.activeDrafts.filter(l => (l.index == null));
        noIndex.forEach(l => {
          l.index = this.runningTotal;
          this.runningTotal++;
        });
        // this.activeDrafts.map((l) => {
        //   l.imgUrl = this.darkMode==true?l.imgUrl.replace('.png',this.darkMode_ext+'.png'):l.imgUrl;
        // });
        // console.log(this.activeDrafts);
        // set league priorities
        this.setPriorities();
        // start timers
        this.startTimers();
        
        this._resultboardService.activeDraftVisibleEmit((this.activeDrafts.length) > 0);
      }
    });
    // pick changes listener (pick_changes)
    if (this.pickChanges) this.pickChanges.unsubscribe();
    this.pickChanges = this._resultboardService.pickChanges().subscribe(r => {
      if (this.activeDrafts != null) {
        // console.log('pickChanges', r);
        let selected = this.activeDrafts.filter(l => l.league_id == r.entities.active_draft.league_id);
        if (selected.length) {
          selected = selected[0];
          Object.keys(r.entities.active_draft).forEach(k => {
            selected[k] = r.entities.active_draft[k];
          });
          if (selected.status == 4) {
            if (selected.timer != null) clearInterval(selected.timer);
            setTimeout(() => {
              let index = -1;
              this.activeDrafts.forEach((l, i) => {
                if (l.league_id == selected.league_id) index = i;
              });
              if (index > -1) this.activeDrafts.splice(index, 1); // remove completed
              this._resultboardService.activeDraftVisibleEmit((this.activeDrafts.length) > 0);
            }, 10000);
          }
          // reset league priorities
          this.setPriorities();
          // restart timer here if needed
          this.startTimers();
        }
        this._resultboardService.activeDraftVisibleEmit((this.activeDrafts.length) > 0);
      }
    });
    // new active league (active_pick_changes)
    if (this.newLeague) this.newLeague.unsubscribe();
    this.newLeague = this._resultboardService.getNewActiveLeague().subscribe(r => {
      r.entities.status = 1;
      this.activeDrafts.push(r.entities);
      if (this.router.url.indexOf('/draft/') == -1) {
        // not on the draft page, should show draft filled dialog here
        // console.log(r);
        this.newDraft(r.entities);
      }
      this._resultboardService.activeDraftVisibleEmit((this.activeDrafts.length) > 0);
    });
    // active drafts emit (active_draft)
    this._resultboardService.emitActiveDraft({
      user_id: this.user.id,
      is_app: 1,
      is_connect: 1
    });
    /**Update deposited amount info */
    if (this.paymentStatus) this.paymentStatus.unsubscribe();
    this.paymentStatus = this._resultboardService.updatePaymentSatus().subscribe(r => {
      console.log(r);
      if (r.status == 1) {
        this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
          width: '500px',
          data: { 'title': 'Deposit Successful', 'body': r.message,'type':'deposit_success'}
        });
      }
    });
  }

  setPriorities() {
    this.activeDrafts.forEach(l => {
      l.priority = 2; // default
      l.width = '100%';
      if (l.status == 4 && l.pick_time >= 600) l.priority = 0; // completed
      if (l.is_active == 1 && l.pick_time >= 600) l.priority = 3; // live
      if (l.status == 1 && l.pick_time >= 600) l.priority = 3; // 2; // predraft
      if ((l.is_paused == 'Y' || l.is_paused == 1) && l.pick_time >= 600) l.priority = 1; // paused
    });
    // live sort code
    // 
    // this.activeDrafts.sort((a, b) => {
    //   if (a.priority == 3 && b.priority == 3) {
    //     // both live
    //     if (a.pick_status == b.pick_status) {
    //       // same pick priority, sort by timeleft
    //       return a.timestamp - b.timestamp; // asc timestamp
    //     } else {
    //       return b.pick_status - a.pick_status; // desc pick order
    //     }
    //   } else {
    //     return b.priority - a.priority; // desc priority
    //   }
    // });
    // no live sorting of live drafts (draft order remains static by index)
    let fastd = this.activeDrafts.filter(ad=>ad.pick_time<600);
    let slowd = this.activeDrafts.filter(ad=>ad.pick_time>=600);
    slowd.sort((a, b) => {
        return a.order_key-b.order_key;
    });
    this.activeDrafts = fastd.concat(slowd);
  }

  startTimers() {
    this.activeDrafts.forEach(l => {
      if (l.timer != null) clearInterval(l.timer);
      if (l.is_active == 1 && (l.is_paused == 'N' || l.is_paused == 0)) {
        l.time_left--;
        l.timer = setInterval(() => {
          l.time_left--;
          l.width = Math.floor((l.time_left / l.pick_time) * 100) + '%';
          if (l.time_left <= 0) clearInterval(l.timer);
        }, 1000);
      }
    });
  }

  isMyPick(league) {
    return (league.pick_status == 1 || league.status == 1) && league.is_active == 1 && (league.is_paused == 'N' || league.is_paused == 0);
  }

  newDraft(league) {
    // console.log(league);
    const dialogRef = this.dialog.open(DraftStartingComponent, {
      width: '360px',
      data: { league },
      autoFocus: false,
      panelClass: 'newDraft'
    });
  }

  showMessage(league) {
    if (this.isMobile) {
      return (league.league_name.length > 15) ? league.league_name.substr(0, 15) + '...' : league.league_name;
    } else {
      return (league.status != 1) ? league.msg : 'Pre-Draft'
    }
  }

  back() {
    window.location.href = `${environment.SITE_URL}/drafts/lobby`;
  }

  showBack() {
    return (this.isMobile && window.location.href.indexOf('/draft/') > -1);
  }

  shouldShow() {
    this.visible = this.activeDrafts.length || (document.location.href.indexOf('/draft/') > -1 && this.isMobile);
    this.visibleChange.emit(this.visible);
    return this.activeDrafts.length || (document.location.href.indexOf('/draft/') > -1 && this.isMobile);
  }
  
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }
}
